// 导航配置
export const navigation = [
  { name: '首页', href: '/' },
  { name: '战队', href: '/teams' },
  { name: '传奇榜', href: '/legends' },
  { name: '说明', href: '/about' },
  { name: '更新', href: '/updates' },
];
